import { type ToastProps } from '@src/components/modals/Toast';
import { createContext, useContext } from 'react';

export type ToastContextType = {
  add: (toast: ToastProps) => string;
  remove: (id: string) => void;
  removeAll: () => void;
};

export const ToastContext = createContext<ToastContextType | undefined>(
  undefined,
);

export function useToast() {
  return useContext(ToastContext);
}
